var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTesting3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3401_4540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.9371C13.5 12.7921 19.2921 7 26.4371 7H64.5629C71.7079 7 77.5 12.7921 77.5 19.9371V58.0629C77.5 65.2079 71.7079 71 64.5629 71H26.4371C19.2921 71 13.5 65.2079 13.5 58.0629V19.9371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4371 7.40428H64.5629C71.4846 7.40428 77.0957 13.0154 77.0957 19.9371V58.0629C77.0957 64.9846 71.4846 70.5957 64.5629 70.5957H26.4371C19.5154 70.5957 13.9043 64.9846 13.9043 58.0629V19.9371C13.9043 13.0154 19.5154 7.40428 26.4371 7.40428Z",
    stroke: "#B1C1CF",
    strokeWidth: 0.808569
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1756 47.3346C50.778 47.3346 54.509 43.6037 54.509 39.0013C54.509 34.3989 50.778 30.668 46.1756 30.668C41.5732 30.668 37.8423 34.3989 37.8423 39.0013C37.8423 43.6037 41.5732 47.3346 46.1756 47.3346Z",
    stroke: "#243251",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8423 40.668C42.8423 40.668 44.0923 42.3346 46.1756 42.3346C48.259 42.3346 49.509 40.668 49.509 40.668",
    stroke: "#243251",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.675 36.5H43.685",
    stroke: "#243251",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.675 36.5H48.685",
    stroke: "#243251",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3401_4540",
    x: 0.562889,
    y: 0.531445,
    width: 89.8742,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3401_4540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3401_4540",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesting3);
export default __webpack_public_path__ + "static/media/Testing3.23e67511fc2ecf91b56df8a42d901567.svg";
export { ForwardRef as ReactComponent };